import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IndicatorTech, IndicatorFundamental, IndicatorPeriod, SelectModel } from '../models.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { PlanificadorService, Interfaceformdata } from '../control.service';
import { MatSelectChange } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { TemaService } from 'src/app/services/tema.services';
import { SseService } from 'src/app/services/SseService';
import { MatIconModule } from '@angular/material/icon';
import { MentionModule } from 'angular-mentions';
import { TablacondicionesComponent } from '../../tablacondiciones/tablacondiciones.component';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DialogIndicadoresComponent } from '../../dialog-indicadores/dialog-indicadores.component';
import { MatDialog } from '@angular/material/dialog';
import { global } from 'src/app/global';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DialogGuardarComponent } from '../../dialog-guardar/dialog-guardar.component';
import { ChatIaDialogComponent, DireccionUI } from '../../chat-ia-dialog/chat-ia-dialog.component';

interface MenuItem {
    label: string;
    action: string;
    submenu?: MenuItem[];  // submenu de primer nivel
    submenu2?: MenuItem[]; // submenu de segundo nivel
    submenu3?: MenuItem[]; // submenu de tercer nivel
    submenu4?: MenuItem[]; // submenu de cuarto nivel
    submenu5?: MenuItem[]; // submenu de quinto nivel
    // Aquí puedes agregar más niveles si es necesario
}

@Component({
    selector: 'app-indicators',
    templateUrl: './indicators.component.html',
    styleUrls: ['./indicators.component.scss'],
})
export class IndicatorsComponent implements OnInit {
    public mentionConfig = {}
    @ViewChild('floatingTable', { static: false }) floatingTable!: TablacondicionesComponent;
    @Input() isModelsRoute: boolean = false;

    replacementIndicators: string[] = ['indicador1', 'indicador2', 'indicador3', 'indicador4'];
    public isDark: boolean = false;
    menuDefinitivo: MenuItem[] = [];
    @Output() frecuencia = new EventEmitter();
    Modelformdata: Interfaceformdata;
    private formdataSubcription: Subscription;
    //public indicator1: any;
    //public indicator2: any;
    public activatedestadoFinancieros: boolean = false;
    public indicadorfundamental3: any;
    public condicion: string = '';
    public condicionHumano: string = '';
    public condicionfundamental: string;
    public subtema: Subscription;
    //public interpretacion:string;
    public interpretacionData: any;
    public loading: boolean = false;
    public sugerencias: any[] = [];
    public modoRespuesta: string = '';
    public token: string = '';

    modelIndicator: IndicatorTech = {
        indicator1: 'Close',

        indicator2: 'MH',
        bar1: 0,
        bar2: 0,
        operator: '',
        value: ''
    } //as IndicatorTech;

    modelIndicatorFundamental: IndicatorFundamental = {
        type: '',
        indicator1: '',
        operator: '>',
        indicator2: '',
        value: '0.1'
    }

    modelIndicatorPeriod: IndicatorPeriod = {
        capFirst: 1000,
        capSuccesive: 100,
        period: 950,
        recoil: 0
    }

    public indicatorsNew: string[] = [];
    public indicatorsFundamentales: string[] = [];
    public indicatorsIa: string[] = [];
    public condicionesIa: string[] = [];

    indicatorsTexts: string[] = ['Macd', 'Macd(signal)'];
    // indicatorsNumbers: string[] = ['Ema', 'Mom', 'Rsi', 'Sma', 'Stddev', 'Sp500', 'Numero'];
    indicatorsNumbers: string[] = [];
    operators: SelectModel[] = [
        {
            description: '>',
            value: '>'
        },
        {
            description: '=',
            value: '='
        },
        {
            description: '<',
            value: '<'
        },
        {
            description: '>=',
            value: '>='
        },
        {
            description: '<=',
            value: '<='
        },
        {
            description: '<>',
            value: '<>'
        }
    ];

    allIndicatorTypes: any;

    indicatorTypes: SelectModel[] = [];

    indicators2: string[] = [];
    indicators3: string[] = []

    tabIndex: number = 0;
    guardando: boolean = false;
    isInValid: boolean = false;
    messageInvalid: string = '';
    private chatIaDialogRef: any = null;

    constructor(private toastr: ToastrService, private location: Location,
        public dialog: MatDialog, private http: HttpClient, private route: ActivatedRoute, public planificadorsv: PlanificadorService, private temaservicio: TemaService, private _sseservice: SseService, private _cookieService: CookieService
    ) {
        this.formdataSubcription = this.planificadorsv.getFormdata().subscribe(datos => {
            this.Modelformdata = datos;
            console.log("desde indicadores constructor: ", this.Modelformdata.condicion);
        });
    }
    interpretarCondicion(): void {
        if (this.chatIaDialogRef) { this.chatIaDialogRef.componentInstance; return; }
        this.chatIaDialogRef = this.dialog.open(ChatIaDialogComponent, {
            width: '33vw',
            height: '70vh',
            panelClass: 'chat-ia-panel',
            disableClose: true,
            hasBackdrop: false,
            data: {
                condicionActual: this.condicion || '',
                token: this.token,
                // Mismo flujo que /strategyfactory: ideas como chatgpt.com y luego traducción al DSL
                modoIdeas: true,
                contexto: { metaapi: this.Modelformdata?.metaapi === true },
                onCondicionChange: (condicion: string, direccion?: DireccionUI) => {
                    this.condicion = condicion;
                    this.isInValid = false;
                    this.messageInvalid = '';
                    this.aplicarDireccion(direccion);
                }
            }
        });
        this.chatIaDialogRef.afterClosed().subscribe(() => { this.chatIaDialogRef = null; });
    }

    // Una condición SHORT en un modelo alcista se ejecutaría como compra
    private aplicarDireccion(direccion?: DireccionUI): void {
        if (!direccion) return;
        const bajista = direccion === 'SHORT';
        if (!!this.Modelformdata.bajista === bajista) return;
        this.Modelformdata.bajista = bajista;
        this.planificadorsv.updateFormdata(this.Modelformdata);
        this.toastr.info(`Dirección del modelo cambiada a ${bajista ? 'Bajista' : 'Alcista'} por la condición ${direccion}`);
    }

    aplicarSugerencia(sugerencia: any): void {
        if (sugerencia.tipo === 'complemento' && this.condicion && this.condicion.trim().length > 0) {
            this.condicion = this.condicion.trim() + ' AND ' + sugerencia.query;
        } else {
            this.condicion = sugerencia.query;
        }
        this.sugerencias = [];
        this.modoRespuesta = 'traduccion';
        this.isInValid = false;
        this.messageInvalid = '';
    }

    resetConversacion(): void {
        // Sin contexto el backend borra el historial de todas las pantallas del usuario
        this._sseservice.apiDelete('conditions/chat?contexto=models', this.token).subscribe({
            next: () => {
                this.sugerencias = [];
                this.modoRespuesta = '';
                this.condicionHumano = '';
            },
            error: (err: any) => {
                console.error('Error al limpiar historial de conversación:', err);
            }
        });
    }
    ngOnInit(): void {
        this.token = this._cookieService.get('auth_token');

        //this.indicator1 = this.modelIndicator.indicator1;
        //  this.indicator2 = this.modelIndicator.indicator2;
        this.planificadorsv.loadIndicatorTypes()
            .then((res: any) => {
                this.allIndicatorTypes = res.data;
                this.indicatorsNumbers = this.allIndicatorTypes.indicadoresTecnicosIA;
                this.indicatorsNew = this.allIndicatorTypes.indicadoresTecnicosIA;
                this.indicatorsFundamentales = this.allIndicatorTypes.indicadoresFundamentalesIA;
                this.indicatorsIa = this.allIndicatorTypes.indicadoresIA;
                this.condicionesIa = this.allIndicatorTypes.condicionesIa;
                this.planificadorsv.indicatorsIaSinEspacios = this.indicatorsIa.map(el => el.replace(' ', '_'));
                let datos: string[] = this.planificadorsv.indicatorsIaSinEspacios;
                datos.push(...this.condicionesIa);
                this.mentionConfig = {
                    mentions: [
                        {
                            items: this.planificadorsv.indicatorsIaSinEspacios,
                            triggerChar: '#', allowSpace: true
                        }
                    ], returnTrigger: true
                };
                let { tiporatios, periodos } = res.data;
                this.frecuencia.emit(periodos)
                tiporatios.forEach((el: any, index: number) => {
                    this.indicatorTypes.push({ description: el, value: index + '' })
                });
            });
        console.log("indicadores type: ", this.indicatorTypes);
        this.subtema = this.temaservicio.valDarkTheme.subscribe({
            next: (data: any) => {
                this.isDark = data;

            }
        });
        this._sseservice.apiPostNew('menu', {}, this.token).subscribe({
            next: (menuData: MenuItem[]) => {
                this.menuDefinitivo = menuData; // Actualiza el menú con los datos recibidos
                //   console.log('Datos recibidos del servidor:', this.menuDefinitivo);
            },
            error: (error: any) => {
                console.error('Error al cargar el menú:', error);
            }
        });

    }

    changeIndicatorTab(event: MatTabChangeEvent) {
        this.tabIndex = event.index;
    }
    restoreWithOriginalWords(sentence: string, wordsToReplace: string[]): string {
        let words = sentence.split('"');
        words = words.map(word => {
            if (word.startsWith('indicador')) {
                const index = parseInt(word.replace('indicador_', '')) - 1;
                return wordsToReplace[index].replaceAll('_', ' ');
            }
            return word;
        });

        return words.join('"');
    }
    async addCondition(tipocondicion: string) {
        console.log(tipocondicion);
        this.planificadorsv.loadingModel = true;
        let condicionorginiarl = this.condicion.replaceAll('#', '');
        condicionorginiarl = condicionorginiarl.toLowerCase();
        let parts: string[] = [];
        if (condicionorginiarl.includes(' y '))
            condicionorginiarl = condicionorginiarl.replaceAll(' y ', ' and ');
        if (condicionorginiarl.includes(' && '))
            condicionorginiarl = condicionorginiarl.replaceAll(' && ', ' and ');
        if (condicionorginiarl.includes(' & '))
            condicionorginiarl = condicionorginiarl.replaceAll(' & ', ' and ');


        if (condicionorginiarl.includes(' and ')) {
            parts = condicionorginiarl.split(' and ');
        } else {
            parts.push(condicionorginiarl);
        }


        if (this.condicion != '') {
            const errorDsl = await this.validarDsl(this.condicion);
            if (errorDsl) {
                this.isInValid = true;
                this.messageInvalid = errorDsl;
                this.planificadorsv.loadingModel = false;
                return;
            }
            if (tipocondicion === 'Indice') {
                this.condicion = this.planificadorsv.idActivoIndice + ':' + this.condicion;
                //si this.planificadorsv.idActivoIndice no existe en this.planificadorsv.idActivosIndice , añadirlo
                if (!this.planificadorsv.idnombreActivosIndice.includes(this.planificadorsv.idActivoIndice)) {
                    this.planificadorsv.idnombreActivosIndice.push([this.planificadorsv.idActivoIndice, this.planificadorsv.nombreActivoIndice]);
                }
                console.log(this.planificadorsv.idnombreActivosIndice);
            }
            if (tipocondicion === 'Volatilidad') {
                this.condicion = this.planificadorsv.idActivoVolatilidad + ':' + this.condicion;
                //si this.planificadorsv.idActivoVolatilidad no existe en this.planificadorsv.idActivosVolatilidad , añadirlo
                if (!this.planificadorsv.idnombreActivosVolatilidad.includes(this.planificadorsv.idActivoVolatilidad)) {
                    this.planificadorsv.idnombreActivosVolatilidad.push([this.planificadorsv.idActivoVolatilidad, this.planificadorsv.nombreActivoVolatilidad]);
                }
            }
            const raw = this.condicion.trim();
            const parts = /\s+AND\s+/i.test(raw) ? raw.split(/\s+AND\s+/i) : [raw];

            // Agrega cada parte a condiciones y deriva de ahí entry/exit, así "a AND b" queda como
            // dos condiciones en ambas listas (el backend ya trata "a AND b" como dos condiciones).
            for (const part of parts) {
                const p = part.trim();
                if (!p) continue;
                this.planificadorsv.condiciones.push([p, tipocondicion, p]);
            }
            this.planificadorsv.sincronizarListasCondiciones();

            //this.planificadorsv.condiciones.push([this.condicion, tipocondicion, this.condicion]);

            this.Modelformdata.condicion = this.planificadorsv.condiciones.join(" && ");
            this.planificadorsv.updateFormdata(this.Modelformdata);
            this.planificadorsv.loadingModel = false;
            this.condicion = '';
            this.condicionHumano = '';
            /** 
        for (let i = 0; i < parts.length; i++) {
            const condicionpart = parts[i];
            let indicaorestemp: string[] = [];
            let condicionreemplazada = this.replaceWithIndicators(condicionpart, indicaorestemp)
            console.log(condicionreemplazada);
            this.loading = true;

            let wordss = condicionpart.split(' ');
            // let indicatorIndex = 1;

            // buscar cada palabra de wordss en this.indicatorsFundamentales y tener el indice
            let indicatorIndex = wordss.map(word => this.indicatorsFundamentales.indexOf(word)).filter(index => index !== -1);
            if (Number(indicatorIndex) > 0) {
                try {
                    const data = await this._sseservice.apiGetNew('check-ratios-exist?idmercado=' + this.Modelformdata.idMercado).toPromise();
                    if (!data) {
                        this.loading = false;
                        this.planificadorsv.loadingModel = false;
                        this.toastr.error('No es posible aplicar condiciones de ratios con esta lista', 'Error', { timeOut: 5000 });
                        return;
                    }
                } catch (error) {
                    console.error(error);
                    return;
                }
            }
            
            this._sseservice.apiPostNew('conditions/get_conditions', '{"input": "' + condicionreemplazada + '"}', '').toPromise()
                .then(response => {
                    if (response.output[0].operador === 'error') {
                        this.toastr.error(response.output[0].other_operador);
                        this.loading = false;
                        this.planificadorsv.loadingModel = false;
                    } else {
                        this.loading = false;
                        console.log(JSON.stringify(response));
                        let finalSentence = this.restoreWithOriginalWords(JSON.stringify(response), indicaorestemp);
                        //                    console.log(finalSentence);
                        this.interpretacionData = JSON.parse(finalSentence);
                        let condicionuno = this.interpretacionData.output[0];
                        if (tipocondicion === 'Indice') {
                            if (condicionuno.asset_name == 0) condicionuno.asset_name = this.planificadorsv.idActivoIndice;
                            if (condicionuno.other_asset_name == 0) condicionuno.other_asset_name = this.planificadorsv.idActivoIndice;
                        }
                        if (tipocondicion === 'Volatilidad') {
                            console.log("entra en volatilidad");
                            console.log(this.planificadorsv.idActivoVolatilidad);
                            if (condicionuno.asset_name == 0) condicionuno.asset_name = this.planificadorsv.idActivoVolatilidad;
                            if (condicionuno.other_asset_name == 0) condicionuno.other_asset_name = this.planificadorsv.idActivoVolatilidad;
                        }
                        console.log(condicionuno);
                        if (tipocondicion === 'Salida') {
                            this.planificadorsv.interpretacionDataListExit.push(condicionuno);
                        } else {
                            this.planificadorsv.interpretacionDataListEntry.push(condicionuno);
                        }
                        this.planificadorsv.condiciones.push([condicionpart.replaceAll('#', ''), tipocondicion, condicionuno]);
                        this.Modelformdata.condicion = this.planificadorsv.condiciones.join(" && ");
                        this.planificadorsv.updateFormdata(this.Modelformdata);
                        this.planificadorsv.loadingModel = false;
                        this.condicion = '';
                        this.condicionHumano = '';
                    }
                }).catch(error => {
                    this.loading = false;
                });





        }
        */
        }
        if (this.location.path().includes('/models?')) {
            const keepAnalisis = this.location.path().includes('modo=analisis');
            this.location.replaceState(`/models`, keepAnalisis ? 'modo=analisis' : '');
        }
    }


    // Pregunta al backend si el motor puede evaluar la condición antes de añadirla: si no, el
    // backtest acababa en un modelo vacío sin explicación. Devuelve el motivo, o null si es válida.
    // Si el endpoint no responde no se bloquea al usuario: el backtest seguirá avisando.
    private async validarDsl(dsl: string): Promise<string | null> {
        try {
            // metaapi: sus activos no tienen ratios fundamentales y el backend rechaza las condiciones que los usan.
            const body = { dsl, metaapi: this.Modelformdata?.metaapi === true };
            const resp: any = await this._sseservice.apiPostNew('conditions/validar_dsl', JSON.stringify(body), this.token).toPromise();
            return resp && resp.ok === false ? (resp.error || 'Condición no válida') : null;
        } catch (error) {
            console.error('No se pudo validar la condición:', error);
            return null;
        }
    }

    // Al editar la condición se quita el error: los botones de añadir se deshabilitan con isInValid.
    onCondicionEditada(): void {
        if (this.isInValid) {
            this.isInValid = false;
            this.messageInvalid = '';
        }
    }

    guardarCondicion() {
        this.guardando = true;
        if (!this.condicion) {
            this.toastr.error('Debe ingresar una condición para guardar');
            this.guardando = false;
            return;
        }

        // Abrir diálogo de guardar
        const dialogRef = this.dialog.open(DialogGuardarComponent, {
            width: '450px',
            backdropClass: 'dialog-backdrop',
            panelClass: 'save-dialog-panel',
            data: {
                condicion: this.condicion,
                condicionHumana: this.condicionHumano, indicatorsIaSinEspacios: this.planificadorsv.indicatorsIaSinEspacios,
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.guardando = false;
            if (result) {
                // Si se seleccionó alguna opción y se confirmó
                this.guardarCondicionEnDestinos(result.destinos);
                // Si ya estaba todo guardado, el diálogo ya ha avisado
                if (result.destinos.length > 0 && !result.todoYaEstaba) {
                    this.toastr.success('Condición guardada correctamente');
                    //this.condicion = '';
                    //this.condicionHumano = '';
                }
            }
        });
    }
    // Método para guardar la condición en los destinos seleccionados
    private guardarCondicionEnDestinos(destinos: string[]) {
        // Implementar la lógica para guardar en cada destino seleccionado
        destinos.forEach(destino => {
            console.log(`Guardando condición en: ${destino}`);
            // Aquí implementar la lógica específica para cada destino
        });
    }
    changeIndicator(indicator3: boolean) {
        let type;
        if (indicator3) { type = this.indicadorfundamental3 }
        else { type = this.modelIndicatorFundamental.type; }

        console.log("esto llega a tipo: ", type);
        switch (type) {
            case 'RATIOS FINANCIERO':
                this.allIndicatorTypes.financiero.push('Numero');
                this.indicators2 = this.allIndicatorTypes.financiero;
                this.activatedestadoFinancieros = false;
                break;
            case 'VALOR EMPRESARIAL':
                this.allIndicatorTypes.valorempresarial.push('Numero');
                this.indicators2 = this.allIndicatorTypes.valorempresarial;
                this.activatedestadoFinancieros = false;
                break;
            case 'CRECIMIENTO ESTADOS FINANCIEROS':
                this.activatedestadoFinancieros = true;
                this.indicators3 = this.allIndicatorTypes.crecimientoestadosfinancieros;
                this.indicators2 = [];
                break;
            case 'METRICAS':
                this.allIndicatorTypes.metricas.push('Numero');
                this.indicators2 = this.allIndicatorTypes.metricas;
                this.activatedestadoFinancieros = false;
                break;
            case 'CRECIMIENTO FINANCIEROS':
                this.allIndicatorTypes.crecimientofinancieros.push('Numero');
                this.indicators2 = this.allIndicatorTypes.crecimientofinancieros;
                this.activatedestadoFinancieros = false;
                break;
            case 'DCF':
                this.allIndicatorTypes.dcf.push('Numero');
                this.indicators2 = this.allIndicatorTypes.dcf;
                this.activatedestadoFinancieros = false;
                break;
            case 'CRECIMIENTO ANUAL CUENTA RESULTADOS':
                this.allIndicatorTypes.crecimientoanualcuentaresultados.push('Numero');
                this.indicators2 = this.allIndicatorTypes.crecimientoanualcuentaresultados;
                this.activatedestadoFinancieros = true;
                break;
            case 'CRECIMIENTO ANUAL BALANCE':
                this.allIndicatorTypes.crecimientoanualbalance.push('Numero');
                this.indicators2 = this.allIndicatorTypes.crecimientoanualbalance;
                this.activatedestadoFinancieros = true;
                break;
            case 'CRECIMIENTO ANUAL FCF':
                this.allIndicatorTypes.crecimientoanualfcf.push('Numero');
                this.indicators2 = this.allIndicatorTypes.crecimientoanualfcf;
                this.activatedestadoFinancieros = true;
                break;
        }

        this.modelIndicatorFundamental.indicator1 = this.indicators2[0];
        this.modelIndicatorFundamental.indicator2 = this.indicators2.find(el => el == 'Numero')!;

    }

    validarDuplicados(array: string[], valoresAProbar: string[]): boolean {
        for (const elemento of array) {
            for (const valor of valoresAProbar) {
                if (elemento.includes(valor)) {
                    return true;
                }
            }
        }
        return false;
    }
    searchInChatGPT() {
        const selectedItem = 'Que es el indicador ' + this.modelIndicatorFundamental.type + ' ';

        if (selectedItem) {
            // Construir la URL con el ítem seleccionado
            const query = encodeURIComponent(selectedItem);
            const url = `https://chat.openai.com/?q=${query}`;

            window.open(url, '_blank');
            //window.location.href = url;
        } else {
            console.warn('Por favor, seleccione un tipo antes de buscar.');
        }
    }
    searchIndicatorFundamentalInChatGPT() {
        const selectedIndicator = this.modelIndicatorFundamental.indicator1;

        if (selectedIndicator) {
            const selectedIndicatorbuscar = 'Que es ratio financiero ' + this.modelIndicatorFundamental.indicator1 + "?";
            // Construir la URL con el ítem seleccionado
            const query = encodeURIComponent(selectedIndicatorbuscar);
            const url = `https://chat.openai.com/?q=${query}`;

            // Redirigir a la URL
            //window.location.href = url;
            window.open(url, '_blank');
        } else {
            console.warn('Por favor, seleccione un indicador antes de buscar.');
        }
    }
    searchIndicatorInChatGPT() {
        const selectedIndicator = 'Que es el indicador ' + this.modelIndicator.indicator1 + "?, dame ejemplos de condiciones para señales con este indicador con los operadores: >, <,=, cruce, etc. y dame condicion en formato screener ";

        if (selectedIndicator) {
            // Construir la URL con el ítem seleccionado
            const query = encodeURIComponent(selectedIndicator);
            const url = `https://chat.openai.com/?q=${query}`;

            // Redirigir a la URL
            //window.location.href = url;
            window.open(url, '_blank');
        } else {
            console.warn('Por favor, seleccione un indicador antes de buscar.');
        }
    }
    actualizarTipoCondicion() {

    }

    replaceWithIndicators(sentence: string, indicadoresIA: string[]): string {
        let words = sentence.split(' ');
        let indicatorIndex = 1;

        words = words.map(word => {
            const index = this.planificadorsv.indicatorsIaSinEspacios.indexOf(word);
            if (index !== -1) { indicadoresIA.push(word) }
            return index !== -1 ? `indicador_${indicatorIndex++}` : word;
        });

        return words.join(' ');
    }




    showTable(event: MouseEvent) {
        console.log('show table');
        // const tableElement = this.floatingTable.elementRef.nativeElement;
        //tableElement.style.display = 'block';
        //tableElement.style.top = `${event.clientY}px`;
        //tableElement.style.left = `${event.clientX}px`;
    }

    hideTable() {
        //const tableElement = this.floatingTable.elementRef.nativeElement;
        //tableElement.style.display = 'none';
    }

    handleButtonClick(event: { label: string, isChecked: string, r: string }): void {
        console.log('Datos recibidos del hijo:', event);
        this.condicion = event.label;
        if (event.r === 't')
            this.condicion = event.label.toLowerCase();
    }

}